export default __webpack_public_path__ + "static/vanhack-958b1fe7cfe62f1f5bd29f12de882ec5.png";